import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import useTranslation from 'ia-react-core/~/hooks/useTranslation';
import { StyledSlogan } from './CorpoSlogan.styles';

export interface CorpoSloganProps {}

/**
 * @since 0.18.0
 */
const CorpoSlogan: FC<CorpoSloganProps> = () => {
  const { t } = useTranslation('Core.CorpoSlogan');

  return (
    <Trans i18nKey="slogan" t={t as unknown as (Parameters<typeof Trans>)[0]['t']}>
      <StyledSlogan></StyledSlogan> <StyledSlogan></StyledSlogan>
    </Trans>
  );
};

/**
 * @component
 */
export default CorpoSlogan;
